export function lazyLoadSlickIframes($slider) {
    const iframes = $('iframe', $slider);

    // on page load switch out all of the srcs to data-src
    iframes.each(function (index, value) {
        const src = $(this).attr('src');

        // set the data-src and wipe the src
        $(this).data('src', src);
        $(this).attr('src', '');

        this.onload = function () {
            $(this).closest('.slick-list').css('min-height',$(this).outerHeight())
        }
    });

    // on gallery init.. (slick slider callback function)
    $slider.on('init', function () {
        // load the first iframe since we are initializing
        iframes.eq(0).attr('src', iframes.eq(0).data('src'));
    });

    // on gallery change.. (slick slider callback function)
    $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        // emptying out the src attribute of the iframe with the index of the current slide
        iframes.eq(currentSlide).attr('src', '');

        // "loading" the next slides iframe
        iframes.eq(nextSlide).attr('src', iframes.eq(nextSlide).data('src'));
    });
}